module.exports = __webpack_public_path__ + "static/media/Industry-Light.8c8fb973.ttf";